import { isWorkflowScheduled } from '@/services/workflows/workflowMappers'

export { selectScheduledThreadIds } from './threadWorkflowFacets'

/**
 * The workflows the Scheduled section lists, by title.
 *
 * Paused ones stay in: pausing keeps the cron (see `pauseWorkflowSchedule`), so
 * `isWorkflowScheduled` still passes and the row remains resumable. Archived
 * ones drop out, because that check requires status 'active'. No conversation
 * is required — a schedule is worth listing even if its chat was deleted.
 *
 * @param {{ id: string, title?: string }[]} workflows
 */
export function selectScheduledWorkflows(workflows = []) {
  return workflows
    .filter((workflow) => isWorkflowScheduled(workflow))
    .sort((a, b) => String(a.title ?? '').localeCompare(String(b.title ?? '')))
}
